import { render, staticRenderFns } from "./NavWallet.vue?vue&type=template&id=2dc4ae95&scoped=true"
import script from "./NavWallet.vue?vue&type=script&lang=js"
export * from "./NavWallet.vue?vue&type=script&lang=js"
import style0 from "./NavWallet.vue?vue&type=style&index=0&id=2dc4ae95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc4ae95",
  null
  
)

export default component.exports